const updatePageBackground = (canvasState, command) => canvasState.set(
    'background',
    command.get('background')
);

export default updatePageBackground;
